<div class="p-20">
  <form [formGroup]="form" class="search-form items-center!" (ngSubmit)="getRepairerSites(true)">
    <mat-form-field class="w-[315px]! remove-end-border-radius no-validation">
      <mat-select
        formControlName="statusFilter"
        (selectionChange)="getRepairerSites(true)"
        panelClass="max-h-[300px]"
        disableOptionCentering="true">
        @for (status of statusOptions; track status) {
          <mat-option [value]="status.value">
            {{ status.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="input-search subtitle-2 remove-start-border-radius no-validation">
      <input matInput formControlName="searchFilter" [placeholder]="searchPlaceholder" cdkFocusInitial />
      @if (searchFilter.value) {
        <mat-icon matSuffix (click)="searchFilter.setValue('')">cancel_24px</mat-icon>
      }
    </mat-form-field>
    <button matButton="elevated" class="red-button" type="submit">SEARCH</button>
  </form>

  <mat-divider />

  @if (!loadingRepairers() && !sysAdminService.repairerSitesList()?.length) {
    @if (searchInputValue()) {
      <div class="search-no-result-found-container">
        <p class="search-no-result-found">
          <mat-icon class="text-red!">warning</mat-icon>
          <span class="search-no-result-found-text">No results could be found. Please review your search.</span>
        </p>
      </div>
    } @else {
      <div class="search-information">
        <mat-icon>info_outline_24px</mat-icon>
        <span class="search-information-text">Define a search criterion to generate a list of repairer.</span>
      </div>
    }
  }

  @if (sysAdminService.repairerSitesList()?.length && !loadingRepairers()) {
    <mat-paginator
      class="body-2 -mb-10"
      (page)="pageSearch($event.pageIndex)"
      [length]="sysAdminService.repairerSitesTotalNumberOfMatchesFound()"
      [pageSize]="pageSize()"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[]"
      [pageIndex]="page.value" />
  }

  @if (sysAdminService.repairerSitesList()?.length) {
    <app-repairer-site-table
      [activeColumn]="'companyName'"
      [loadingRepairers]="loadingRepairers()"
      [currentUserTimezone]="userTimezone"
      [columnInfos]="columnHeadersRepairerSites"
      [repairerSites]="sysAdminService.repairerSitesList()"
      (rowItemClicked)="getRepairerSite($event)"
      (columnHeaderOrderChange)="sortedSearch($event?.sort, $event?.direction)"
      (kebabMenuClicked)="kebabMenuClick($event)">
    </app-repairer-site-table>
  }

  <loading-spinner [spinnerHeight]="20" [loading]="loadingRepairers()" />
</div>
